import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-ff4af41e")

_pushScopeId("data-v-ff4af41e")
const _hoisted_1 = { class: "card rounded-0 border-0 shadow-sm mb-5" }
const _hoisted_2 = { class: "card-img-container position-relative" }
const _hoisted_3 = { class: "card-img-overlay overlay-logo text-center" }
const _hoisted_4 = { class: "project-logo" }
const _hoisted_5 = { class: "card-title font-weight-bold" }
const _hoisted_6 = { class: "card-text" }
const _hoisted_7 = { class: "card-body pb-0" }
const _hoisted_8 = { class: "card-title text-truncate text-center mb-0" }
const _hoisted_9 = { class: "card-footer border-0 text-center bg-white pb-4" }
const _hoisted_10 = { class: "list-inline mb-0 mx-auto" }
const _hoisted_11 = { class: "badge bg-secondary badge-pill" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("div", {
    class: ["col-12 col-lg-4", _ctx.project.filterTags]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("img", {
          class: "card-img-top rounded-0",
          src: `/images/projects/${_ctx.project.thumbnail}`,
          alt: ""
        }, null, 8, ["src"]),
        _createVNode(_component_router_link, {
          to: { name: `project-${_ctx.project.slug}` }
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_3, [
              _createVNode("div", _hoisted_4, [
                _createVNode("img", {
                  class: "img-fluid w-50 white",
                  src: `/images/logos/${_ctx.project.thumbnailLogo}`
                }, null, 8, ["src"])
              ])
            ])
          ]),
          _: 1
        }, 8, ["to"]),
        _createVNode(_component_router_link, {
          class: "card-img-overlay overlay-content text-start p-lg-4",
          to: { name: `project-${_ctx.project.slug}` }
        }, {
          default: _withId(() => [
            _createVNode("h5", _hoisted_5, _toDisplayString(_ctx.project.summaryTitle), 1),
            _createVNode("p", _hoisted_6, _toDisplayString(_ctx.project.summary), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode("h4", _hoisted_8, [
          _createVNode(_component_router_link, {
            lass: "text-link",
            to: { name: `project-${_ctx.project.slug}` }
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.project.name), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("ul", _hoisted_10, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.project.badges, (badge) => {
            return (_openBlock(), _createBlock("li", {
              key: badge,
              class: "list-inline-item"
            }, [
              _createVNode("span", _hoisted_11, _toDisplayString(badge), 1)
            ]))
          }), 128))
        ])
      ])
    ])
  ], 2))
})